(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // Cart page: keep the minimum-order lock current and save quantities as
  // they change. theme.js updates the stepper on the same click, so values
  // are read a tick later. Listeners sit on document because the section is
  // swapped for a fresh render after every save.
  (function () {
    var timer = null, seq = 0;

    function form() { return document.querySelector('[data-min-cart]'); }

    function recalc(f) {
      var notice = f.querySelector('[data-min-notice]');
      var button = f.querySelector('[data-checkout]');
      if (!notice || !button) return;
      var d = notice.dataset;
      var minA = parseInt(d.minA, 10) || 1, minB = parseInt(d.minB, 10) || 1;
      // qb = other cases, qp = the brand with its own minimum (Poland Spring).
      var qa = 0, qb = 0, qp = 0, equip = false;
      f.querySelectorAll('[data-min-group]').forEach(function (line) {
        var input = line.querySelector('[data-qty-input]');
        var n = input ? parseInt(input.value, 10) || 0 : 0;
        var flags = line.dataset.minFlags || '';
        if (flags.indexOf('e') > -1 && (!input || n > 0)) equip = true;
        if (line.dataset.minGroup === 'a') qa += n;
        if (flags.indexOf('p') > -1) qp += n;
        else if (line.dataset.minGroup === 'b') qb += n;
      });
      var cases = qb + qp;
      var need = minA * minB, score = qa * minB + cases * minA;
      // A cart with equipment has no minimum.
      var blocked = !!d.enabled && !equip && score > 0 && score < need;
      // '\x7b' / '\x7d' are the braces, spelled out so the Liquid parser leaves them alone.
      function fill(tpl, vals) {
        return tpl.replace(/\x7b(\w+)\x7d/g, function (m, k) { return k in vals ? vals[k] : m; });
      }
      // Brand rule: its own minimum, unless the rest meets the minimum alone or
      // the cart holds that many cases in total.
      var brandMin = parseInt(d.brandMin, 10) || 4;
      var rest = qa * minB + qb * minA;
      var brandBlocked = !!d.enabled && !!d.brandEnabled && !equip && qp > 0 &&
        qp < brandMin && cases < brandMin && rest < need;
      if (brandBlocked) {
        blocked = true;
        var toTotal = brandMin - cases;
        notice.querySelector('[data-min-msg]').textContent = fill(d.brandTemplate, {
          label: d.brandLabel, min: brandMin,
          add_brand: Math.min(brandMin - qp, toTotal),
          add_other: Math.min(Math.ceil((need - rest) / minA), toTotal)
        });
      } else if (blocked) {
        var gap = need - score;
        notice.querySelector('[data-min-msg]').textContent = fill(d.template, {
          min_a: minA, min_b: minB, label_a: d.labelA, label_b: d.labelB,
          add_a: Math.ceil(gap / minB), add_b: Math.ceil(gap / minA) });
      }
      notice.hidden = !blocked;
      button.disabled = blocked;
    }

    // Subscribed jugs: "New bottles needed" can never exceed that jug's count,
    // and the one bottle charge is the sum of them. Returns true when a count
    // had to come down, so the charge's breakdown is rewritten after saving.
    function syncBottles(f) {
      var total = 0, capped = false;
      f.querySelectorAll('[data-nb-control]').forEach(function (ctl) {
        var line = ctl.closest('[data-line-key]'), input = line && line.querySelector('[data-qty-input]');
        var out = ctl.querySelector('[data-nb-value]');
        var max = input ? parseInt(input.value, 10) || 0 : 0;
        var v = parseInt(out.textContent, 10) || 0;
        if (v > max) { v = max; capped = true; out.textContent = v; }
        total += v;
      });
      f.querySelectorAll('[data-role="fee"]').forEach(function (fee, i) {
        var input = fee.querySelector('[data-qty-input]'), out = fee.querySelector('[data-qty-value]');
        var want = i === 0 ? total : 0;
        if (input) input.value = want;
        if (out) out.textContent = want;
      });
      return capped;
    }
    function nbCounts() {
      var counts = {};
      document.querySelectorAll('[data-nb-control]').forEach(function (c) {
        counts[c.dataset.pid] = parseInt(c.querySelector('[data-nb-value]').textContent, 10) || 0;
      });
      return counts;
    }

    function save() {
      var f = form();
      if (!f || !window.fetch) return Promise.resolve();
      var updates = {};
      f.querySelectorAll('[data-qty-input]').forEach(function (input) {
        updates[input.name.slice(8, -1)] = parseInt(input.value, 10) || 0; // updates[KEY]
      });
      var mine = ++seq;
      var sectionId = f.dataset.sectionId;
      f.classList.add('is-saving');
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sectionId })
      })
        .then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); })
        .then(function (cart) {
          if (mine !== seq) return; // a newer tap is on its way; let it win
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          var html = cart.sections && cart.sections[sectionId];
          var wrap = document.getElementById('shopify-section-' + sectionId);
          if (html && wrap) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('shopify-section-' + sectionId);
            if (fresh) wrap.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () { if (mine === seq) f.submit(); }) // fall back to a normal cart post
        .finally(function () { var g = form(); if (g && mine === seq) g.classList.remove('is-saving'); });
    }

    document.addEventListener('click', function (e) {
      var f = form();
      if (!f || !f.contains(e.target) || !e.target.closest('[data-qty-up], [data-qty-down]')) return;
      var capped = false;
      setTimeout(function () { capped = syncBottles(f) || capped; recalc(f); }, 0);
      clearTimeout(timer);
      timer = setTimeout(function () {
        var p = save();
        // Fewer jugs than new bottles: rewrite the charge's breakdown too.
        if (capped && p) p.then(function () {
          return rebuild(null, null, nbCounts()).then(function (changed) { if (changed) window.location.reload(); });
        });
      }, 450);
    });

    // ---- One valid shape for the cart -------------------------------------
    // Every change of mode (and every visit) rebuilds the cart from what it
    // means: per jug, how many jugs and how many of them are new bottles.
    // Lines are compared by variant + plan + properties; if they already match
    // nothing is sent. Otherwise the cart is cleared and refilled in one add,
    // and put back as it was if that add is refused.
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) });
    }
    function cleanProps(p) {
      var o = {};
      if (p) Object.keys(p).sort().forEach(function (k) { if (p[k] !== null && p[k] !== '') o[k] = p[k]; });
      return o;
    }
    function planOf(i) { return i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null; }
    function shape(list) {
      var m = {};
      list.forEach(function (i) {
        if (!i.quantity) return;
        var k = i.id + '|' + (i.selling_plan || '') + '|' + JSON.stringify(cleanProps(i.properties));
        m[k] = (m[k] || 0) + i.quantity;
      });
      return JSON.stringify(Object.keys(m).sort().map(function (k) { return k + '=' + m[k]; }));
    }
    function forAdd(i) {
      var o = { id: Number(i.id), quantity: i.quantity };
      if (i.selling_plan) o.selling_plan = Number(i.selling_plan);
      var p = cleanProps(i.properties);
      if (Object.keys(p).length) o.properties = p;
      return o;
    }

    // mode: 'sub' | 'once' | null (null = keep each jug's own mode, just tidy).
    function wanted(items, f, mode, planId, nbCount) {
      var dom = {}, jugs = {}, byRefill = {};
      f.querySelectorAll('[data-line-key]').forEach(function (el) {
        var d = el.dataset;
        dom[d.lineKey] = { role: d.role || '', pid: d.jugProduct || '', plans: (d.linePlans || '').split(',').filter(Boolean) };
        if (d.jugProduct && !jugs[d.jugProduct]) {
          jugs[d.jugProduct] = { refill: Number(d.jugRefill), nb: Number(d.jugNb), title: d.jugTitle || '', plans: dom[d.lineKey].plans };
          byRefill[d.jugRefill] = d.jugProduct;
        }
      });
      var cartPlan = null;
      items.forEach(function (i) { if (!cartPlan && planOf(i)) cartPlan = planOf(i); });
      if (planId) planId = Number(planId);

      var out = [], agg = {}, feeCounts = {};
      items.forEach(function (i) {
        var info = dom[i.key] || { role: '', plans: [] }, pid = null;
        if (info.role === 'fee') {
          // Bottle charges are collected per jug and written back as ONE line below.
          var props = i.properties || {}, left = i.quantity;
          var pairs = String(props._nb_counts || '').split(',').filter(Boolean);
          if (!pairs.length && props._nb_link) pairs = [String(props._nb_link) + ':' + i.quantity];
          pairs.forEach(function (pair) {
            var kv = pair.split(':'), id = jugs[kv[0]] ? kv[0] : byRefill[kv[0]];
            var n = Math.min(parseInt(kv[1], 10) || 0, left);
            left -= n;
            if (id && n) feeCounts[id] = (feeCounts[id] || 0) + n;
          });
          return; // a charge for a jug no longer in the cart simply goes
        } else if (info.role === 'refill' || info.role === 'nb') {
          pid = info.pid;
        }
        if (pid) {
          if (!agg[pid]) { agg[pid] = { refillSub: 0, refillOnce: 0, nbSub: 0, nbOnce: 0, fee: 0, plan: null }; out.push({ jug: pid }); }
          var a = agg[pid], p = planOf(i);
          if (info.role === 'refill') { if (p) { a.refillSub += i.quantity; a.plan = a.plan || p; } else a.refillOnce += i.quantity; }
          else { if (p) { a.nbSub += i.quantity; a.plan = a.plan || p; } else a.nbOnce += i.quantity; }
          return;
        }
        var plan = planOf(i);
        if (mode === 'once') plan = null;
        else if (mode === 'sub') { if (planId && info.plans.indexOf(String(planId)) > -1) plan = planId; }
        else if (plan && cartPlan && plan !== cartPlan && info.plans.indexOf(String(cartPlan)) > -1) plan = cartPlan;
        out.push({ id: i.variant_id, quantity: i.quantity, selling_plan: plan, properties: i.properties });
      });

      var propName = f.dataset.nbProperty || 'For', feeId = Number(f.dataset.nbFee) || 0, res = [];
      var charge = [], chargeAt = -1;
      out.forEach(function (o) {
        if (!o.jug) { res.push(o); return; }
        var a = agg[o.jug], j = jugs[o.jug];
        a.fee = feeCounts[o.jug] || 0;
        var jugCount = a.refillSub + a.refillOnce + a.nbSub + a.nbOnce;
        var newBottles = Math.min(a.fee + a.nbSub + a.nbOnce, jugCount);
        if (nbCount && nbCount[o.jug] != null) newBottles = Math.max(0, Math.min(nbCount[o.jug], jugCount));
        var sub = mode ? mode === 'sub' : (a.refillSub + a.nbSub) > 0;
        if (sub) {
          var plan = planId || cartPlan || a.plan;
          if (j.plans.indexOf(String(plan)) < 0) plan = Number(j.plans[0]);
          if (jugCount) res.push({ id: j.refill, quantity: jugCount, selling_plan: plan, properties: {} });
          if (newBottles && feeId) { charge.push({ pid: o.jug, n: newBottles, title: j.title }); chargeAt = res.length; }
        } else {
          if (jugCount - newBottles) res.push({ id: j.refill, quantity: jugCount - newBottles, selling_plan: null, properties: {} });
          if (newBottles) res.push({ id: j.nb, quantity: newBottles, selling_plan: null, properties: {} });
        }
      });
      if (charge.length) {
        var pr = { _nb_counts: charge.map(function (c) { return c.pid + ':' + c.n; }).join(',') };
        pr[propName] = charge.map(function (c) { return c.title + ' ×' + c.n; }).join(', ');
        var total = charge.reduce(function (s, c) { return s + c.n; }, 0);
        res.splice(chargeAt, 0, { id: feeId, quantity: total, selling_plan: null, properties: pr });
      }
      return res;
    }

    // Resolves true when the cart was rewritten (the caller reloads).
    function rebuild(mode, planId, nbCount) {
      var f = form();
      if (!f || !window.fetch) return Promise.resolve(false);
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = cart.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity, selling_plan: planOf(i), properties: i.properties }; });
          var want = wanted(cart.items, f, mode, planId, nbCount);
          if (shape(want) === shape(have)) return false;
          var keep = want.filter(function (i) { return i.quantity > 0; });
          // Nothing left but a bottle charge: just empty the cart (an add with
          // no items is refused, and the fallback would put the charge back).
          if (!keep.length) return post('/cart/clear.js').then(function () { return true; });
          return post('/cart/clear.js')
            .then(function () { return post('/cart/add.js', { items: keep.map(forAdd) }); })
            .then(function (r) {
              if (r.ok) return true;
              return post('/cart/add.js', { items: have.map(forAdd) }).then(function () { return true; });
            });
        });
    }

    function switchTo(mode, planId) {
      var box = document.querySelector('[data-cart-sub]');
      if (box) {
        clearTimeout(timer);
        box.classList.add('is-busy');
        var status = box.querySelector('[data-cart-sub-status]');
        if (status) status.hidden = false;
      }
      rebuild(mode, planId).catch(function () {}).then(function () { window.location.reload(); });
    }

    // Remove: take the line out, then rebuild so a bottle charge for a jug
    // that is gone goes with it. Done here rather than by following the
    // link, so it never depends on the once-per-few-seconds visit tidy.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.cart-remove');
      var f = form();
      if (!link || !f || !f.contains(link) || !window.fetch) return;
      var line = link.closest('[data-line-key]');
      if (!line) return;
      e.preventDefault();
      clearTimeout(timer);
      f.classList.add('is-saving');
      post('/cart/change.js', { id: line.dataset.lineKey, quantity: 0 })
        .then(function (r) { if (!r.ok) throw new Error('remove failed'); return rebuild(null); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.href = link.href; });
    });

    // "New bottles needed" on a subscribed jug: 0 up to that line's jugs.
    var nbTimer = null;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nb-up], [data-nb-down]');
      if (!btn) return;
      var ctl = btn.closest('[data-nb-control]'), line = btn.closest('[data-line-key]');
      var out = ctl.querySelector('[data-nb-value]');
      var input = line ? line.querySelector('[data-qty-input]') : null;
      var max = input ? parseInt(input.value, 10) || 0 : 0;
      var n = (parseInt(out.textContent, 10) || 0) + (btn.hasAttribute('data-nb-up') ? 1 : -1);
      n = Math.max(0, Math.min(n, max));
      out.textContent = n;
      clearTimeout(nbTimer);
      nbTimer = setTimeout(function () {
        ctl.classList.add('is-busy');
        rebuild(null, null, nbCounts()).catch(function () {}).then(function () { window.location.reload(); });
      }, 600);
    });

    // On every visit: put the cart in its valid shape (once per few seconds,
    // so a cart Shopify will not take in that shape cannot reload forever).
    (function () {
      var last = 0;
      try { last = Number(sessionStorage.getItem('cartShapeAt')) || 0; } catch (e) {}
      if (Date.now() - last < 8000) return;
      rebuild(null).then(function (changed) {
        if (!changed) return;
        try { sessionStorage.setItem('cartShapeAt', String(Date.now())); } catch (e) {}
        window.location.reload();
      }).catch(function () {});
    })();

    document.addEventListener('change', function (e) {
      var box = e.target.closest('[data-cart-sub]');
      if (!box) return;
      var sel = box.querySelector('[data-cart-sub-plan]');
      if (e.target.matches('[data-cart-sub-mode]')) {
        var sub = e.target.value === 'sub';
        box.classList.toggle('is-sub', sub);
        switchTo(sub ? 'sub' : 'once', sub && sel ? sel.value : null);
      } else if (e.target === sel) {
        switchTo('sub', sel.value);
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cart-sub-apply]')) return;
      var sel = document.querySelector('[data-cart-sub-plan]');
      switchTo('sub', sel ? sel.value : null);
    });

    document.addEventListener('submit', function (e) {
      var f = form();
      if (e.target !== f || !e.submitter || e.submitter.name !== 'checkout') return;
      recalc(f);
      if (f.querySelector('[data-checkout]').disabled) e.preventDefault();
      else clearTimeout(timer); // the checkout post carries the quantities itself
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Refill note: visible while the selected option is a Refill (a bottle swap).
  document.querySelectorAll('[data-refill-note]').forEach(function (note) {
    var set = note.closest('fieldset');
    if (!set) return;
    set.querySelectorAll('[data-swatch]').forEach(function (b) {
      b.addEventListener('click', function () { note.hidden = !b.hasAttribute('data-refill'); });
    });
  });

  // Purchase options: the plan select only posts when "subscribe" is chosen,
  // and the prices on the page follow the choice. Subscription prices come
  // from Liquid (data-plan-<id>, already formatted); one-time prices from the
  // same data-variant-* the card script uses, so switching back restores them.
  document.querySelectorAll('[data-sub-box]').forEach(function (box) {
    var select = box.querySelector('[data-sub-plan]');
    var modes = box.querySelectorAll('[data-sub-mode]');
    var card = box.closest('[data-product-card]') || document;
    var showPrice = box.dataset.subShowPrice !== 'false';
    var strike = box.dataset.subStrike !== 'false';

    // A price is only crossed out when the plan really is cheaper: with no
    // discount on the plan, both prices match and nothing is struck.
    function strikeFor(subPrice, once) { return strike && subPrice && subPrice !== once ? once : ''; }

    function setWas(el, text) {
      if (!el) return;
      el.textContent = text || '';
      if (text) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    }

    var nbNote = box.querySelector('[data-nb-note]');
    var nbError = box.querySelector('[data-nb-error]');

    function selected() { return card.querySelector('[data-swatch].is-selected'); }

    // New bottle on a subscription: the note says what the first delivery and
    // the ones after it cost. Prices come pre-formatted from Liquid.
    function note(sub) {
      if (!nbNote) return;
      var s = selected();
      var plan = select ? select.value : '';
      var then = s && plan ? s.getAttribute('data-plan-then-' + plan) : null;
      if (sub && s && s.dataset.nbRefill && then) {
        nbNote.textContent = (nbNote.dataset.template || '')
          .split('[bottle]').join(s.dataset.nbBottlePrice || '')
          .split('[price]').join(then);
        nbNote.hidden = false;
      } else {
        nbNote.hidden = true;
      }
    }

    function prices(sub) {
      note(sub);
      var plan = sub && showPrice && select ? select.value : '';
      // Option buttons
      card.querySelectorAll('[data-swatch]').forEach(function (b) {
        var d = b.dataset;
        var subPrice = plan && d.variantAvailable === 'true' ? b.getAttribute('data-plan-' + plan) : null;
        var priceEl = b.querySelector('[data-choice-price]');
        var unitEl = b.querySelector('[data-choice-unit]');
        if (priceEl && d.variantAvailable === 'true') priceEl.textContent = subPrice || d.variantPrice;
        if (unitEl && d.variantUnit) unitEl.textContent = (subPrice && b.getAttribute('data-plan-unit-' + plan)) || d.variantUnit;
        setWas(b.querySelector('[data-choice-was]'), subPrice ? strikeFor(subPrice, d.variantPrice) : d.variantCompare);
        b.classList.toggle('has-sub-price', !!subPrice);
      });
      // Price row: follows the selected button, or the product itself.
      var row = card.querySelector('[data-price-row]');
      if (!row) return;
      var src = card.querySelector('[data-swatch].is-selected') || row;
      var d = src.dataset;
      var subPrice = plan ? src.getAttribute('data-plan-' + plan) : null;
      var priceEl = row.querySelector('[data-card-price]');
      var unitEl = row.querySelector('[data-card-unit]');
      if (priceEl && d.variantPrice) priceEl.textContent = subPrice || d.variantPrice;
      if (unitEl && d.variantUnit) unitEl.textContent = (subPrice && src.getAttribute('data-plan-unit-' + plan)) || d.variantUnit;
      setWas(row.querySelector('[data-card-compare]'), subPrice ? strikeFor(subPrice, d.variantPrice) : d.variantCompare);
    }

    function isSub() {
      return !modes.length || Array.prototype.some.call(modes, function (r) { return r.checked && r.value === 'sub'; });
    }

    function sync() {
      var sub = isSub();
      if (select) select.disabled = !sub;
      box.classList.toggle('is-sub', sub);
      if (nbError) nbError.hidden = true;
      prices(sub);
    }
    modes.forEach(function (r) { r.addEventListener('change', sync); });
    if (select) select.addEventListener('change', sync);
    // The card script rewrites the price row on a button click; re-apply after it.
    card.querySelectorAll('[data-swatch]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(sync, 0); });
    });
    sync();

    // New bottle + subscribe: add the Refill option on the plan and the bottle
    // charge once, instead of the New bottle option (which would repeat the
    // bottle on every delivery, or is not on the plan at all). Runs before
    // theme.js's own add handler, which listens on document.
    var form = document.getElementById('pdp-form');
    if (form && window.fetch) form.addEventListener('submit', function (e) {
      var s = selected();
      if (form.dataset.added || !isSub() || !s || !s.dataset.nbRefill || !select) return;
      e.preventDefault();
      e.stopPropagation();
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      // _nb_link ties the bottle charge to this jug (product id); the cart
      // keeps one charge per new bottle and drops it if the jug goes.
      var props = { _nb_link: String(box.dataset.productId) };
      props[box.dataset.nbProperty || 'For'] = s.dataset.nbFor || '';
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      if (nbError) nbError.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(s.dataset.nbRefill), quantity: qty, selling_plan: Number(select.value) },
          { id: Number(s.dataset.nbBottle), quantity: qty, properties: props }
        ] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          // Same "View cart" state theme.js gives a normal add.
          var label = document.body.dataset.atcButton;
          if (submit && label) {
            form.dataset.added = '1';
            submit.classList.add('is-added');
            submit.textContent = label;
          }
        })
        .catch(function () { if (nbError) nbError.hidden = false; })
        .finally(function () { if (submit) submit.disabled = false; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-change"] && !Shopify.designMode) return;
  try {
    
  // Change-my-subscription form: steppers from 0, the cart's combined
  // minimum, and rows left at 0 are not sent.
  (function () {
    var form = document.querySelector('[data-sc-form]');
    if (!form) return;
    var notice = form.querySelector('[data-sc-min]');
    var submit = form.querySelector('[data-sc-submit]');

    function check() {
      if (!notice || !submit) return;
      var d = notice.dataset;
      var minA = parseInt(d.minA, 10) || 1, minB = parseInt(d.minB, 10) || 1;
      var qa = 0, qb = 0, total = 0;
      form.querySelectorAll('[data-sc-row]').forEach(function (row) {
        var n = parseInt(row.querySelector('[data-sc-input]').value, 10) || 0;
        total += n;
        row.classList.toggle('is-on', n > 0);
        if (row.dataset.minGroup === 'a') qa += n;
        if (row.dataset.minGroup === 'b') qb += n;
      });
      var need = minA * minB, score = qa * minB + qb * minA;
      // Same rule as the cart: only products in a minimum group count.
      var blocked = !!d.enabled && score > 0 && score < need;
      if (blocked) {
        var gap = need - score;
        // '\x7b' / '\x7d' are the braces, spelled out so the Liquid parser leaves them alone.
        var vals = { min_a: minA, min_b: minB, label_a: d.labelA, label_b: d.labelB,
                     add_a: Math.ceil(gap / minB), add_b: Math.ceil(gap / minA) };
        notice.querySelector('[data-sc-min-msg]').textContent = d.template.replace(/\x7b(\w+)\x7d/g, function (m, k) {
          return k in vals ? vals[k] : m;
        });
      }
      notice.hidden = !blocked;
      submit.disabled = total === 0 || blocked;
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sc-up], [data-sc-down]');
      if (!btn) return;
      var box = btn.closest('[data-sc-stepper]');
      var input = box.querySelector('[data-sc-input]');
      var n = (parseInt(input.value, 10) || 0) + (btn.hasAttribute('data-sc-up') ? 1 : -1);
      n = Math.max(0, Math.min(99, n));
      input.value = n;
      box.querySelector('[data-sc-value]').textContent = n;
      check();
    });

    form.addEventListener('submit', function (e) {
      check();
      if (submit && submit.disabled) { e.preventDefault(); return; }
      // Only what the customer wants goes in the email.
      form.querySelectorAll('[data-sc-input]').forEach(function (input) {
        if ((parseInt(input.value, 10) || 0) === 0) input.disabled = true;
      });
    });

    check();
  })();

  } catch(e) { console.error(e); }
})();
})();
